// extracted by mini-css-extract-plugin
export default {"card":"styles_card__EJGEk","content":"styles_content__v8n4z"};